import React from 'react'
import styled, { keyframes } from 'styled-components'
import { CreditCardBrandEnum } from 'enums'

interface CreditCardImageProps {
  creditCardBrand: string
}

const CreditCardImage: React.FC<CreditCardImageProps> = ({ creditCardBrand }) => {
  switch (creditCardBrand) {
    case CreditCardBrandEnum.Visa:
      return (
        <AnimationFadeIn>
          <img src={`${process.env.PUBLIC_URL}/assets/payment/visa.svg`} alt="icon-visa-card" />
        </AnimationFadeIn>
      )
    case CreditCardBrandEnum.MasterCard:
      return (
        <AnimationFadeIn>
          <img src={`${process.env.PUBLIC_URL}/assets/payment/master-card.svg`} alt="icon-master-card" />
        </AnimationFadeIn>
      )
    case CreditCardBrandEnum.JCB:
      return (
        <AnimationFadeIn>
          <img style={{ height: '24px' }} src={`${process.env.PUBLIC_URL}/assets/payment/jcb.svg`} alt="icon-jcb" />
        </AnimationFadeIn>
      )
    case CreditCardBrandEnum.AMEX:
      return (
        <AnimationFadeIn>
          <img style={{ height: '24px' }} src={`${process.env.PUBLIC_URL}/assets/payment/amex.svg`} alt="icon-amex" />
        </AnimationFadeIn>
      )
    case CreditCardBrandEnum.UnionPay:
      return (
        <AnimationFadeIn>
          <img
            style={{ height: '24px' }}
            src={`${process.env.PUBLIC_URL}/assets/payment/unionpay.svg`}
            alt="icon-unionpay"
          />
        </AnimationFadeIn>
      )
    default:
      return null
  }
}

export default CreditCardImage

const FadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const AnimationFadeIn = styled.div`
  animation: ${FadeIn} 0.6s forwards;
`
